import { translate as t } from "../localization";

const spainTranslations = {
  "benefit-meal-tooltip": t("benefits-section.meal-benefit.meal-tooltip"),
  "benefit-nursery-tooltip": t(
    "benefits-section.nursery-benefit.nursery-tooltip"
  ),
  "benefit-education-tooltip": t(
    "benefits-section.education-benefit.education-tooltip"
  ),
  "nursery-advanced-config-description": t(
    "benefits-section.nursery-benefit.es-nursery-advanced-config-description"
  ),
  "health-insurance": t(
    "benefits-section.health-insurance-benefit.health-insurance"
  ),
  "health-insurance-tooltip": t(
    "benefits-section.health-insurance-benefit.health-insurance-tooltip"
  ),
  "bag-removal-tooltip-3": t("subsidy-section.bag-removal-tooltip-3"),
  "tooltip-health-insurance-1": t(
    "benefits-section.tooltips.health-insurance-1"
  ),
  "tooltip-health-insurance-2": t(
    "benefits-section.tooltips.health-insurance-2"
  ),
  "tooltip-health-insurance-3": t(
    "benefits-section.tooltips.health-insurance-3"
  ),
  "v2.benefits.health-insurance.name": `v2.benefits.health-insurance.name`,
};

export default spainTranslations;
